/**
 * Created by Dennis Wang
 * on 2019-04-10 18:26
 *
 * @format
 */

import { Platform, StatusBar } from 'react-native';
import { JDDevice, JDNativeSystem } from '@jdreact/jdreact-core-lib';

let osVersion = 0;

const Device = {
  /**
   * 获取导航条高度：默认: 44
   * @return {number}
   */
  getNavigationBarHeight() {
    return 44;
  },

  isIos() {
    return Platform.OS === 'ios';
  },

  isAndroid() {
    return Platform.OS === 'android';
  },

  isWeb() {
    return Platform.OS === 'web';
  },

  /**
   * 获取设备状态栏高度：JDNativeSystem 适配了刘海屏
   *
   * 知识点：
   *    ios: （默认：全屏）
   *        iphone: statusBar: 20
   *        iphoneX: statusBar: 54 (正常 34，为屏幕中间刘海留出 20 距离)
   *
   *    android:
   *        android4.4 (sdk 18) 页面不包含状态栏（非全屏）
   *        android5.0 (sdk 21) 页面包含状态栏（全屏）
   *
   * @return {Number} 状态栏高度
   */
  getStatusBarHeight() {
    if (Platform.OS === 'ios') {
      return JDNativeSystem.statusBarHeight;
    }
    return StatusBar.currentHeight;
  },

  /**
   * 获取底部tab高度
   * @returns {*}
   */
  getBottomNavBarHeight() {
    return JDNativeSystem.isIPhoneX ? JDDevice.getRpx(168) : JDDevice.getRpx(100);
  },

  /**
   * 检查页面是否是全屏。即：页面是否包含状态栏:（true：全屏、false：非全屏）
   *
   * 注意：实际使用时需要考虑全屏 Android 状态栏是否透明的情况，如果不透明还是和非全屏一样效果。
   *
   *    主要原因：
   *    Android 低版本 SDK 状态栏不包含在页面里：非全屏。
   *      sdk version <= 18 状态栏不包含在页面里（非全屏）；
   *      sdk version > 18 状态栏都包含在页面里（全屏）。
   *
   *    iOS 页面始终包含状态栏。（全屏）
   *
   * @param fullScreen 强制页面包含状态栏（全屏）
   * @returns {boolean}
   */
  // eslint-disable-next-line consistent-return
  isFullScreen(fullScreen = true) {
    if (Platform.OS === 'android') {
      // Android 根据sdk 版本判断：<= 18 非全屏，页面包含状态栏
      if (fullScreen) {
        return true;
      }
      return Number(Platform.Version) > 19;
    } else if (Platform.OS === 'ios') {
      return true;
    }
  },
  /**
   * 检查系统版本
   */
  isLowSdkVersion(transparent) {
    if (Platform.OS === 'ios') {
      return false;
    }
    if (!transparent) {
      return true;
    }
    return this.getOSVersion() <= 18;
  },

  getOSVersion() {
    if (osVersion === 0) {
      if (Platform.OS === 'android') {
        JDNativeSystem.getOSVersion().then((data) => {
          osVersion = data;
          return osVersion;
        });
      }
    }
  },
};

module.exports = Device;
